import { motion } from 'framer-motion';
import { cn } from '../lib/cn';

export function Container({ className, children }: { className?: string; children: React.ReactNode }) {
  return <div className={cn('mx-auto w-full max-w-7xl px-5 sm:px-6 lg:px-8', className)}>{children}</div>;
}

export function Section({
  className,
  children,
  id
}: {
  className?: string;
  children: React.ReactNode;
  id?: string;
}) {
  return (
    <section id={id} className={cn('py-20 sm:py-24', className)}>
      <Container>{children}</Container>
    </section>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  body,
  align = 'left'
}: {
  eyebrow?: string;
  title: string;
  body?: string;
  align?: 'left' | 'center';
}) {
  return (
    <div className={cn('max-w-3xl', align === 'center' && 'mx-auto text-center')}>
      {eyebrow ? (
        <p className="mb-3 text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">{eyebrow}</p>
      ) : null}
      <h2 className="font-display text-4xl leading-tight text-brand-dark sm:text-5xl">{title}</h2>
      {body ? <p className="mt-5 text-lg leading-8 text-brand-muted">{body}</p> : null}
    </div>
  );
}

export function Reveal({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
